import { render, staticRenderFns } from "./TaskResources.vue?vue&type=template&id=a8b46e4a"
import script from "./TaskResources.vue?vue&type=script&lang=js"
export * from "./TaskResources.vue?vue&type=script&lang=js"
import style0 from "./TaskResources.vue?vue&type=style&index=0&id=a8b46e4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports